






























































































































































































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { getMerchantByOrgIdNotIncludeSon, listPackage, addMerchantPackageRecord } from '@/api/package-management/index';
import Utils from '@root/utils/common';
import { couponTypeMap } from '@/types/package-management/dictionaries';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import OrganizationSearch from '@/components/organization-search/index.vue';
import ModalConfig from '@/components/modal-config/index.vue';
import moment from 'moment';
import * as _ from 'lodash';
import { postivePrice, smallPrice } from '@root/utils/validators';
import { isShiDaisy } from '@root/utils/env';
export interface IForm {
  orgId: string;
  merchantId: string; //商家Id
  packageId: string; // 套餐名称
  limits: string; //购买数量
  paidAmount: string; //套餐售价
  send: string; //是否推送商业消息
}
@Component({
  name: 'AddEditModal',
  components: { ParkingLotSearch, ModalConfig, OrganizationSearch }
})
export default class AddEditModal extends Vue {
  // 是否编辑状态
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  // 编辑状态回填数据
  @Prop()
  data!: any;
  //是否是详情
  @Prop({ type: Boolean, default: false })
  isDetail!: boolean;

  form: any = null;
  labelCol = { span: 6 };
  wrapperCol = { span: 15 };
  id = '';
  confirmLoading: boolean = false;
  couponOptions = [];
  merchantName = '';
  private moment = moment;
  merchantList: any[] = [];
  price: string = '0';
  packageData: any = {
    price: '',
    discountPrice: '',
    limits: 1,
    packageExpirationDate: '',
    packageType: '',
    quota: ''
  };
  validatorPrice = smallPrice;
  isSdshangye: boolean = isShiDaisy;
  //form初始化
  init() {
    this.couponOptions = [];
    if (this.isEdit && this.data) {
      this.form = this.$form.createForm(this);
    } else {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            send: this.$form.createFormField({
              value: '00'
            })
          };
        }
      });
    }
  }
  //提交表单
  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        // const limit = this.form.getFieldValue('limits')
        // if (this.packageData && this.packageData.limits != 0) {
        //   if (limit > this.packageData.limits)
        //     return this.$message.error(`购买最大数量为${this.packageData.limits}，请重新输入`)
        // }
        this.onAddOrEdit(values);
      } else {
        console.log('错误', err);
      }
    });
  }
  //新增保存表单
  async onAddOrEdit(values: IForm) {
    if (this.confirmLoading) return;
    this.confirmLoading = true;
    try {
      const json = {
        ...values
      };
      const { status, msg } = await addMerchantPackageRecord(json);
      this.successTip(status, msg);
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '套餐购买'}失败`);
    } finally {
      this.confirmLoading = false;
    }
  }
  //成功提示
  successTip(status: string, msg: any) {
    if (status === '9999') {
      this.$message.success(`${this.isEdit ? '编辑' : '套餐购买'}成功`);
      this.form.resetFields();
      this.$emit('create');
    } else {
      this.$message.error(msg ? msg : `${this.isEdit ? '编辑' : '套餐购买'}失败`);
    }
  }
  //切换机构 商家列表更新
  async changeorgDep(val: any) {
    this.getMerchantList(val);
    this.form.setFieldsValue({
      merchantId: ''
    });
  }
  //获取商家列表
  async getMerchantList(val: any) {
    const { data } = await getMerchantByOrgIdNotIncludeSon({ orgdepId: val });
    this.merchantList = data;
  }
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }
  Mul(arg1: { toString: () => any }, arg2: { toString: () => any }) {
    var r1 = arg1.toString(),
      r2 = arg2.toString(),
      m,
      resultVal,
      d = arguments[2];
    m = (r1.split('.')[1] ? r1.split('.')[1].length : 0) + (r2.split('.')[1] ? r2.split('.')[1].length : 0);
    resultVal = (Number(r1.replace('.', '')) * Number(r2.replace('.', ''))) / Math.pow(10, m);
    // @ts-ignore
    return typeof d !== 'number' ? Number(resultVal) : Number(resultVal.toFixed(parseInt(d)));
  }
  //购买数量变化时
  onChange(val: { toString: () => any }) {
    if (this.packageData.discountPrice) {
      this.form.setFieldsValue({
        paidAmount: String(this.Mul(this.packageData.discountPrice, val))
      });
    } else {
      this.form.setFieldsValue({
        paidAmount: String(this.Mul(this.packageData.price, val))
      });
    }
  }
  //所选商家发生变化时
  async changeMerchant(val: any) {
    this.getCouponList(val);
    this.form.setFieldsValue({
      packageId: ''
    });
  }
  //获取套餐列表
  async getCouponList(val: any) {
    const { data } = await listPackage({ merchantId: val });
    this.couponOptions = data;
  }
  //所选套餐发生变化时
  changePackage(val) {
    this.packageData = this.couponOptions.filter(item => item.pkPackageId == val)[0];
  }
  //搜索过滤
  filterOption(input: string, option: { componentOptions: { children: { text: string }[] } }) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  mounted() {
    this.init();
  }
  smallPriceTip() {
    const _self = this;
    return function(rule: any, value: any, callback: Function) {
      if (!value) callback();
      else {
        if (_self.packageData) {
          if (Number(value) > Number(_self.packageData.limits)) {
            callback(new Error(`购买最大数量为${_self.packageData.limits}，请重新输入`));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
  }
}
